
import styles from "./PartWork.module.scss";
import { useEffect, useState } from "react";
import PartWorkItem from './PartWorkItem/PartWorkItem';
import TestChangeForm from "components/Forms/TestForm/TestChangeForm";
const PartWork = ({ id, setRender, partWorkTests }) => {

  const [edit_id, setEditId] = useState(null);

  const ChangeRowOn = (id) => {
    setEditId(id);
  }
  
  return (
    <div className={styles.test_card}>
      {partWorkTests.map((item, index) =>
        item.id !== edit_id ? (
          <PartWorkItem
            item={item}
            index={index}
            setRender={setRender}
            MassLength={partWorkTests.length}
            ChangeRowOn={ChangeRowOn}
          />
        ) : (
          <TestChangeForm item={item} setRender={setRender} ChangeRowOn={ChangeRowOn} />
          
        )
      )}


    </div >

  );
};

export default PartWork;
